export default {
  'unauthorized subscription':
    'Não foi possível processar o pagamento da sua assinatura. Por favor, verifique os dados do seu cartão ou tente novamente com outro método de pagamento.',
  'Card expired.':
    'O cartão informado está vencido. Por favor, atualize os dados do seu cartão ou utilize outro meio de pagamento.',
  'The number field is not a valid card number':
    'O número do cartão de crédito fornecido é inválido. Verifique os dados e tente novamente.',
  'Could not detect card brand.': 'Não foi possível detectar a bandeira do cartão.',
  'There are validation errors': 'Erro ao validar formulário.',
  'The card expiration date is invalid.': 'A data de validade do cartão é inválida.',
  'The field exp_month must be between 1 and 12': 'O mês de expiração deve estar entre 1 e 12.',
  '"cvv" must be a safe number': 'CVV deve ser um número válido.',
};
